import { Stack, Typography } from '@mui/material';
import { NoDataFound2 } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const NoMedicalReferralsFound = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.MedicalReferrals);
  const isDesktop = useIsDesktop();

  return (
    <NoDataFound2
      gap={isDesktop ? '48px' : '32px'}
      headerComponent={
        <Stack gap='8px' alignItems={'center'}>
          <Typography variant='h2' color='text.secondary' alignSelf={'center'}>
            {dictionary.title}
          </Typography>
          <Stack
            justifyContent={'center'}
            alignItems={'center'}
            direction={isDesktop ? 'row' : 'column'}
            marginBottom={isDesktop ? '20px' : undefined}
          >
            <Typography
              variant='body1'
              color='text.secondary'
              marginRight={'5px'}
            >
              {dictionary.noData.labels.title}
            </Typography>
            <Typography variant={'body3'} color='text.secondary'>
              {dictionary.noData.labels.subtitle}
            </Typography>
          </Stack>
        </Stack>
      }
      redirects={dictionary.noData.redirects}
    />
  );
};
